<template>
    <form class="campaign-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['title']}">
            <label for="title" class="col-sm-2 control-label">Título</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title" v-model="data.title">
                <div class="help-block" v-for="e in errors['title']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['text']}">
            <label for="text" class="col-sm-2 control-label">Contenido</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="text" v-model="data.text" rows="5"></textarea>
                <div class="help-block" v-for="e in errors['text']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['btn_text']}">
            <label for="btn_text" class="col-sm-2 control-label">Texto botón</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="btn_text" v-model="data.btn_text">
                <div class="help-block" v-for="e in errors['btn_text']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['tooltip']}">
            <label for="tooltip" class="col-sm-2 control-label">Texto ayuda botón</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="tooltip" v-model="data.tooltip">
                <div class="help-block" v-for="e in errors['tooltip']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['url']}">
            <label for="url" class="col-sm-2 control-label">Url</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="url" v-model="data.url">
                <div class="help-block" v-for="e in errors['url']">{{e}}</div>
            </div>
        </div>
        <div class="design">
            <div class="form-group">
                <label class="col-sm-3 control-label subtitle"><em>Opciones de Diseño</em></label>
            </div>
            <div class="form-group" :class="{'has-error': errors['bg_image']}">
                <label for="url" class="col-sm-2 control-label">Imagen de Fondo</label>
                <div class="col-sm-10">
                    <el-upload
                    class="upload-demo"
                    action="backend/campanas/upload/"
                    :auto-upload="false"                                
                    :on-change="handleOnChange"
                    :multiple="false"
                    :file-list="fileList">
                    <el-button size="small" type="primary">Subir Imagen</el-button>
                    <div slot="tip" class="el-upload__tip">archivos .PNG con tamaño menor a 512kb</div>
                    </el-upload>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['bg_color']}">
                <label for="bg_color" class="col-sm-2 control-label">Color de Fondo</label>
                <div class="col-sm-10">
                    <div class="col-sm-4 column-color"><input type="text" class="form-control color-control" id="url" v-model="data.bg_color"></div>
                    <div class="col-sm-1 column-color"><el-color-picker v-model="data.bg_color"></el-color-picker></div>
                    <a class="col-sm-7 control-label" style="text-align:left;" @click="data.bg_color='#E5EEF3'">Valor por defecto</a>
                    <div class="help-block" v-for="e in errors['bg_color']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['title_color']}">
                <label for="title_color" class="col-sm-2 control-label">Color de Título</label>
                <div class="col-sm-10">                
                    <div class="col-sm-4 column-color"><input type="text" class="form-control color-control" id="url" v-model="data.title_color"></div>
                    <div class="col-sm-1 column-color"><el-color-picker v-model="data.title_color"></el-color-picker></div>
                    <a class="col-sm-7 control-label" style="text-align:left;" @click="data.title_color='#1B3886'">Valor por defecto</a>
                    <div class="help-block" v-for="e in errors['title_color']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['text_color']}">
                <label for="text_color" class="col-sm-2 control-label">Color de texto</label>
                <div class="col-sm-10">
                    <div class="col-sm-4 column-color"><input type="text" class="form-control color-control" id="url" v-model="data.text_color"></div>
                    <div class="col-sm-1 column-color"><el-color-picker v-model="data.text_color"></el-color-picker></div>
                    <a class="col-sm-7 control-label" style="text-align:left;" @click="data.text_color='#272727'">Valor por defecto</a>
                    <div class="help-block" v-for="e in errors['text_color']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['btn_color']}">
                <label for="btn_color" class="col-sm-2 control-label">Color de botón</label>
                <div class="col-sm-10">
                    <div class="col-sm-4 column-color"><input type="text" class="form-control color-control" id="url" v-model="data.btn_color"></div>
                    <div class="col-sm-1 column-color"><el-color-picker v-model="data.btn_color"></el-color-picker></div>
                    <a class="col-sm-7 control-label" style="text-align:left;" @click="data.btn_color='#E53F40'">Valor por defecto</a>
                    <div class="help-block" v-for="e in errors['btn_color']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['btn_text_color']}">
                <label for="btn_text_color" class="col-sm-2 control-label">Color de texto de botón</label>
                <div class="col-sm-10">
                    <div class="col-sm-4 column-color"><input type="text" class="form-control color-control" id="url" v-model="data.btn_text_color"></div>
                    <div class="col-sm-1 column-color"><el-color-picker v-model="data.btn_text_color"></el-color-picker></div>
                    <a class="col-sm-7 control-label" style="text-align:left;" @click="data.btn_text_color='#FFFFFF'">Valor por defecto</a>
                    <div class="help-block" v-for="e in errors['btn_text_color']">{{e}}</div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">&nbsp;</div>
                <div slot="tip" class="el-upload__tip sm-offset-3"><em>Puede observar el diseño implementado pulsando el botón Previsualizar.</em></div>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" @click="preview()">Previsualizar</a>                
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['active']}">
            <label class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <div class="radio">
                    <label><input type="radio" v-model="data.active" :value="true" /> Si</label></br>
                    <label><input type="radio" v-model="data.active" :value="false" /> No</label>
                </div>
                <div class="help-block" v-for="e in errors['active']">{{e}}</div>
            </div>
        </div>
        

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/campanas">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>    
    .el-upload{
        display: block !important;
    }
    .color-control {
        width: 200px;
    }
    .column-color {
        padding-left:0px;padding-right:0px;
    }
    .design {
        background: #F7F7F7;
        border: 1px solid #F7F7F7;
        border-radius: 4px;
        display: block;
        padding-top: 14px;
        margin-bottom: 7px;
    }
    .subtitle {
        color: #757575;
    }
</style>
<script>
    import Vue from 'vue';    
    import ElUpload from 'element-ui/lib/upload';
    import ElButton from 'element-ui/lib/button';
    import ElColorPicker from 'element-ui/lib/color-picker';
    import { Message } from 'element-ui';
    
    var url2 = baseUrl;
    export default {
        data: function(){
            const data = {                
                id: null,
                title: '',
                text: '',
                btn_text: '',
                tooltip: '',
                url: '',
                bg_image: null,
                bg_file_name: null,
                bg_color: null,
                title_color: null,
                text_color: null,
                btn_color: null,
                btn_text_color: null,
                active: null,
                created_at: null,
                updated_at: null
            };            
            const imageUrl = null;
            return{
                data: _.assign(data, this.campaign),
                fileList: [],
                disabled: false,
                imageUrl: imageUrl,
                attemptPreview: false,
                errors: {}
            }
        },
        props: ['campaign','edit'], 
        components: {
            ElUpload,
            ElButton
        },
        created: function(){
            if(this.data.bg_image){
                this.fileList = [{name: this.data.bg_file_name, url: this.data.bg_image}];
            }
            var self=this;
            for (const key in self.data) {
                self.data[key] = (self.data[key] === null) ? '' : self.data[key];
            }
        },
        computed: {
            validatePreview: function() { 
                var title = this.data.title === '';
                var text = this.data.text === '';
                var btn_text  = this.data.btn_text === '';
                var url = this.data.url === '';
                var url_blank = /\s/g.test(this.data.url);
                var url_slash = _.includes(this.data.url, '//');
                var errores = {};

                if(title){ errores["title"] = ["El campo Título no puede estar vacío."]; }
                if(text){ errores["text"] = ["El campo Texto no puede estar vacío."]; }
                if(btn_text){ errores["btn_text"] = ["El campo Texto botón no puede estar vacío."]; }
                if(url){ errores["url"] = ["El campo Url no puede estar vacío."]; }
                if(url_blank){ errores["url"] = ["El campo Url no puede contener espacios."]; }                

                
                if (title || text || btn_text || url || url_blank){
                    this.errors = errores;
                    return true; 
                }else{
                    return false;
                }
            }
        },
        methods:{            
            handleOnChange(file, fileList) {
                var constPng = file.raw.type === 'image/png';
                var constSize = file.raw.size / 1024;                
                var self = this;
                if(constPng){
                    if(constSize > 512){
                        self.$message.error('La imagen a subir no debe exceder los 512kB.');
                        fileList.splice(0,fileList.length);
                    }else{
                        if (fileList.length >1){
                            self.$message.error('Solo se acepta la carga de una imagen.');
                            fileList.splice(-1);
                        }else{
                            var file = file.raw;
                            self.data.bg_file_name = file.name;
                            var reader = new FileReader();
                            reader.onloadend = function() {
                                self.data.bg_image = reader.result;
                            }
                            reader.readAsDataURL(file);
                        }
                    }
                }else{
                    self.$message.error('La imagen a subir debe ser formato PNG.');
                    fileList.splice(0,fileList.length);
                }                
            },
            preview(){
                var self = this;
                self.attemptPreview = true;
                if (self.validatePreview){
                    self.$message.error('Revise los errores en el formulario para previsualizar contenido.');
                }else{
                    var urlexcl = self.data.url;
                    var urlexcl = (urlexcl.charAt(urlexcl.length - 1) === '/') ? urlexcl.slice(0,urlexcl.length-1) : urlexcl;
                    self.data.url = urlexcl;
                    self.errors = {};
                    var form = document.createElement("form");
                    form.target = "_blank";
                    form.method = "POST";
                    form.action = "/backend/campanas/previsualizar";
                    form.style.display = "none";
                    
                    for (const key in self.data) {
                        var input = document.createElement("input");
                        input.type = "hidden";
                        input.name = key;
                        input.value = self.data[key];
                        form.appendChild(input);
                    }
                    //add token
                    var input = document.createElement("input");
                    input.type = "hidden";
                    input.name = "_token";
                    input.value = document.querySelector('meta[name="csrf-token"]').content;
                    form.appendChild(input);

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
            },
            submit: function(){
                var self = this;
                if (self.validatePreview){
                    self.$message.error('Debe completar los campos requeridos para continuar.');
                }else{
                    var urlexcl = self.data.url;
                    var urlexcl = (urlexcl.charAt(urlexcl.length - 1) === '/') ? urlexcl.slice(0,urlexcl.length-1) : urlexcl;
                    self.data.url = urlexcl;
                    axios({
                    url: self.edit ? 'backend/campanas/'+self.data.id : 'backend/campanas',
                    method: self.edit ? 'PUT' : 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                    self.$message.error('Revise los errores en el formulario para continuar.');
                });
                }
            }
        }
    }
</script>